import { simpleVehicleGroupSchema } from './vehicle-group.schema';
import { z } from 'zod/v4';

export const placeSetSchema = z.object({
  id: z.number(),
  name: z.string(),
  vehicleGroups: z.array(simpleVehicleGroupSchema),
  isDefault: z.boolean(),
});

export type PlaceSet = z.infer<typeof placeSetSchema>;
